import { Button, ButtonProps } from '@mui/material';
import { FC, ReactNode, useMemo } from 'react';
import SuspenseLoader from 'components/SuspenseLoader';
import './ButtonV2.scss';

export type CustomBtnSize = 's' | 'm' | 'l';

export type Varriant = 'primary' | 'secondary' | 'tertiary';

type BaseProps = Omit<ButtonProps, 'size' | 'type'> & {
  size?: CustomBtnSize;
  isLoading?: boolean;
  className?: string;
  type?: Varriant;
};

type IconOnlyProps = BaseProps & {
  iconOnly: true;
  icon: ReactNode;
};

type WithChildrenProps = BaseProps & {
  iconOnly?: false;
  icon?: ReactNode;
  children: ReactNode;
};

type Props = IconOnlyProps | WithChildrenProps;

const ButtonV2: FC<Props> = ({
  children,
  size = 'l',
  className,
  isLoading,
  icon,
  type = 'primary',
  iconOnly = false,
  ...props
}) => {
  const btnClass = useMemo(() => {
    if (type === 'secondary') {
      return 'secondary-btn';
    }

    if (type === 'tertiary') {
      return 'tertiary-btn';
    }

    return 'primary-btn';
  }, [type]);

  return (
    <Button
      {...props}
      variant="contained"
      className={`btn-v2 ${btnClass} btn-size-${size}${className ? ` ${className}` : ''}`}
    >
      <div className={`${iconOnly ? 'icon-only' : ''} hover-state`}>
        {!iconOnly && children}
        {isLoading ? <SuspenseLoader isFullScreen={false} /> : icon ?? null}
      </div>
    </Button>
  );
};

export default ButtonV2;
